import { useMemo, useState, type ReactNode } from "react";
import type { Script, ScriptForm } from "@/features/dashboard/types";
import { 
  DashboardDialogsContext, 
  type DashboardDialogsContextValue,
  type ManageParticipantsState,
  type ShareDialogState
} from "./dashboardDialogsContext";

export const DashboardDialogsProvider = ({ children }: { children: ReactNode }) => {
  const [showAddScript, setShowAddScript] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [selectedScriptForm, setSelectedScriptForm] = useState<{ scriptForm: ScriptForm; scriptName: string; script: Script } | null>(null);
  const [manageParticipantsState, setManageParticipantsState] = useState<ManageParticipantsState>({ open: false, scriptForm: null, scriptName: "" });
  const [shareDialogState, setShareDialogState] = useState<ShareDialogState>({ open: false, script: null, scriptForm: null });

  const value = useMemo<DashboardDialogsContextValue>(() => ({
    showAddScript,
    openAddScript: () => setShowAddScript(true),
    closeAddScript: () => setShowAddScript(false),

    showSettings,
    openSettings: () => setShowSettings(true),
    closeSettings: () => setShowSettings(false),

    selectedScriptForm,
    openAnalysisDialog: (scriptForm, scriptName, script) => setSelectedScriptForm({ scriptForm, scriptName, script }),
    closeAnalysisDialog: () => setSelectedScriptForm(null),

    manageParticipantsState,
    openManageParticipants: ({ scriptForm, scriptName }) => setManageParticipantsState({ open: true, scriptForm, scriptName }),
    closeManageParticipants: () => setManageParticipantsState({ open: false, scriptForm: null, scriptName: "" }),

    shareDialogState,
    openShareDialog: (script, scriptForm) => setShareDialogState({ open: true, script, scriptForm }),
    closeShareDialog: () => setShareDialogState({ open: false, script: null, scriptForm: null }),
    setShareDialogState,
  }), [showAddScript, showSettings, selectedScriptForm, manageParticipantsState, shareDialogState]);

  return (
    <DashboardDialogsContext.Provider value={value}>
      {children}
    </DashboardDialogsContext.Provider>
  );
};
